import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Support Icon Component
 *
 * A headset/support icon for customer support links.
 */
const SupportIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 3600 3600">
      <path
        d="m3070.8 1195.2c-136.8-586.8-666-1004.4-1270.8-1004.4-608.4 0-1134 417.6-1270.8 1004.4-226.8 75.602-388.8 284.4-388.8 532.8v547.2c0 262.8 183.6 482.4 428.4 543.6 133.2 277.2 406.8 453.6 720 453.6h180c32.398 108 133.2 187.2 252 187.2h194.4c147.6 0 266.4-118.8 266.4-266.4 0-147.6-118.8-266.4-266.4-266.4h-194.4c-108 0-201.6 64.801-244.8 158.4h-190.8c-205.2 0-388.8-100.8-500.4-262.8 136.8-36 241.2-162 241.2-313.2l0.003906-1018.8c0-169.2-133.2-309.6-298.8-324 144-464.4 576-792 1069.2-792 496.8 0 928.8 327.6 1069.2 792-165.6 14.398-298.8 151.2-298.8 324v1018.8c0 180 144 324 324 324 309.6 0 561.6-252 561.6-561.6v-543.6c3.6016-248.4-158.4-457.2-381.6-532.8zm-1346.4 1918.8h194.4c43.199 0 79.199 36 79.199 79.199s-36 79.199-79.199 79.199h-194.4c-43.199 0-79.199-36-79.199-79.199 0-46.801 32.402-79.199 79.199-79.199zm-882-1623.6v1018.8c0 75.602-61.199 136.8-136.8 136.8-205.2 0-374.4-169.2-374.4-374.4v-543.6c0-205.2 169.2-374.4 374.4-374.4 72.004 0 136.8 61.199 136.8 136.8zm2426.4 784.8c0 205.2-169.2 374.4-374.4 374.4-75.602 0-136.8-61.199-136.8-136.8v-1022.4c0-75.602 61.199-136.8 136.8-136.8 205.2 0 374.4 169.2 374.4 374.4z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default SupportIcon;
